export default __webpack_public_path__ + "static/media/minimize.3b6fe8a4.svg";